import React, { useState } from "react";

// Popup "🔀 Conversione" (vedi OrdiniMapping.jsx, colonna mappata come
// "Colonna sorgente editabile"): per ogni codice del fornitore trovato nel
// file che non ha ancora una corrispondenza salvata, si scrive a mano il
// codice giusto (il MIO codice articolo/variante/combinazione). A
// differenza della legenda sviluppi qui non c'è un vocabolario chiuso da
// rispettare — il valore giusto è testo libero, deciso da chi risolve — e
// una volta salvato vale per SEMPRE su questo template (fornitore): ai
// prossimi ordini dello stesso fornitore quel codice si converte da solo.
export default function ConversioneCodiciModal({ campo, valoriDaRisolvere, onSalvaMappature, onChiudi }) {
  const [valori, setValori] = useState({}); // { codiceGrezzo: mio codice }
  const [salvando, setSalvando] = useState(false);
  const [errore, setErrore] = useState("");

  function impostaValore(grezzo, valore) {
    setValori((prev) => ({ ...prev, [grezzo]: valore }));
  }

  const pronteDaSalvare = valoriDaRisolvere.filter((v) => (valori[v] || "").trim() !== "");

  async function applicaRisolti() {
    if (pronteDaSalvare.length === 0) return;
    setErrore("");
    setSalvando(true);
    try {
      const mappature = {};
      for (const v of pronteDaSalvare) mappature[v] = valori[v].trim();
      await onSalvaMappature(mappature);
      // Tolgo dallo stato locale solo quelle appena risolte: il genitore
      // ricalcola valoriDaRisolvere dopo il salvataggio, quindi spariscono
      // da sole dalla lista qui sopra.
      setValori((prev) => {
        const copia = { ...prev };
        for (const v of pronteDaSalvare) delete copia[v];
        return copia;
      });
    } catch (e) {
      setErrore(e.message);
    } finally {
      setSalvando(false);
    }
  }

  return (
    <div
      style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "rgba(15, 23, 42, 0.75)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000, fontFamily: "Inter, sans-serif" }}
      onClick={onChiudi}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{ backgroundColor: "var(--cf-bg-card)", borderRadius: "16px", width: "640px", maxWidth: "92vw", maxHeight: "88vh", display: "flex", flexDirection: "column", overflow: "hidden", boxShadow: "0 25px 60px rgba(0,0,0,0.45)" }}
      >
        <div style={{ background: "linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)", padding: "18px 22px", display: "flex", justifyContent: "space-between", alignItems: "center", flexShrink: 0 }}>
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <span style={{ fontSize: "20px", lineHeight: 1 }}>🔀</span>
            <div>
              <div style={{ fontFamily: "'Roboto Mono', Consolas, monospace", fontWeight: 700, fontSize: "15px", letterSpacing: "1px", textTransform: "uppercase", color: "#f1f5f9" }}>
                Conversione codici
              </div>
              <div style={{ fontFamily: "'Roboto Mono', Consolas, monospace", fontSize: "11px", color: "var(--cf-text-faint)", letterSpacing: "0.3px", marginTop: "3px" }}>
                {campo}
              </div>
            </div>
          </div>
          <button className="cf-btn" onClick={onChiudi} style={{ border: "none", background: "rgba(255,255,255,0.08)", borderRadius: "6px", width: "28px", height: "28px", padding: 0, display: "flex", alignItems: "center", justifyContent: "center", fontSize: "14px", cursor: "pointer", color: "#cbd5e1", lineHeight: 1 }}>
            ✕
          </button>
        </div>

        <div style={{ padding: "24px", overflowY: "auto" }}>
          {errore && <p className="errore" style={{ marginTop: 0 }}>{errore}</p>}

          <p className="testo-secondario" style={{ marginTop: 0 }}>
            Per ogni codice del fornitore scrivi il tuo codice corrispondente — si salva una volta sola: al
            prossimo ordine dello stesso fornitore con lo stesso codice, la conversione si applica da sola.
          </p>

          <div style={{ fontSize: "11px", fontWeight: 700, color: "var(--cf-text-muted)", textTransform: "uppercase", letterSpacing: "0.6px", marginBottom: "8px", fontFamily: "'Roboto Mono', Consolas, monospace" }}>
            Da risolvere in questo file ({valoriDaRisolvere.length})
          </div>
          {valoriDaRisolvere.length === 0 ? (
            <p className="testo-secondario" style={{ marginTop: 0 }}>
              Nessun codice senza corrispondenza — tutti già convertiti.
            </p>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
              {valoriDaRisolvere.map((v) => (
                <div key={v} style={{ display: "flex", alignItems: "center", gap: "8px", padding: "8px 10px", borderRadius: "8px", backgroundColor: "var(--cf-bg-subtle)", border: "1px solid var(--cf-border)" }}>
                  <span style={{ flex: "1 1 auto", fontSize: "13px", wordBreak: "break-word" }} title={v}>{v}</span>
                  <span style={{ color: "var(--cf-text-faint)" }}>→</span>
                  <input
                    type="text"
                    placeholder="il tuo codice..."
                    value={valori[v] || ""}
                    onChange={(e) => impostaValore(v, e.target.value)}
                    onKeyDown={(e) => { if (e.key === "Enter") applicaRisolti(); }}
                    style={{ minWidth: "12rem" }}
                  />
                </div>
              ))}
              <button
                className="btn-primario"
                onClick={applicaRisolti}
                disabled={salvando || pronteDaSalvare.length === 0}
                style={{ alignSelf: "flex-start" }}
              >
                {salvando ? "Salvataggio..." : `Applica e salva (${pronteDaSalvare.length}/${valoriDaRisolvere.length})`}
              </button>
            </div>
          )}
        </div>

        <div style={{ padding: "16px 24px", borderTop: "1px solid var(--cf-border)", display: "flex", justifyContent: "flex-end", flexShrink: 0 }}>
          <button onClick={onChiudi}>Chiudi</button>
        </div>
      </div>
    </div>
  );
}
